import { generateRequest } from '.';

export const Action = {
  GeoIp: {
    GeoIpPending: 'GeoIp_PENDING',
    GeoIpCompleted: 'GeoIp_FULFILLED',
    GeoIpFailed: 'GeoIp_FAILED',
  },
};

export const fetchGeoLocation = () => generateRequest({
  endpoint: '/assets-v2/api/geo/ip',
  types: [
    Action.GeoIp.GeoIpPending,
    Action.GeoIp.GeoIpCompleted,
    Action.GeoIp.GeoIpFailed,
  ],
});
